import { render, staticRenderFns } from "./RtoObjectiveItem.vue?vue&type=template&id=06522e4a&scoped=true&"
import script from "./RtoObjectiveItem.vue?vue&type=script&lang=js&"
export * from "./RtoObjectiveItem.vue?vue&type=script&lang=js&"
import style0 from "./RtoObjectiveItem.vue?vue&type=style&index=0&id=06522e4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06522e4a",
  null
  
)

export default component.exports